<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Dashboard",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "LAB MALWARE",
      items: [
        {
          text: "User Management",
          href: "/",
        },
        {
          text: "user List",
          active: true,
        },
      ],
      statData: [
        {
          icon: "bx bx-copy-alt",
          title: "Orders",
          value: "1,235",
        },
        {
          icon: "bx bx-archive-in",
          title: "Revenue",
          value: "$35, 723",
        },
        {
          icon: "bx bx-purchase-tag-alt",
          title: "Average Price",
          value: "$16.2",
        },
      ],
      transactions: [
        {
          id: "#SK2540",
          name: "Neal Matthews",
          uname: "partta.man",
          email: "matt.max@yahoo.com",
          join_at: "01-01-2010",
          role: "Analyst",
        },
        {
          id: "#SK2541",
          name: "Jamal Burnett",
          uname: "anonmoe",
          email: "br8377@gmail.com",
          join_at: "02-10-2007",
          role: "Validator",
        },
        {
          id: "#SK2542",
          name: "Juan Mitchell",
          uname: "hackdoor99",
          email: "juju88@yahoo.com",
          join_at: "22-02-2010",
          role: "Analyst",
        },
        {
          id: "#SK2543",
          name: "Barry Dick",
          uname: "barrymark",
          email: "anonme.lock@yahoo.com",
          join_at: "15-08-2011",
          role: "Analyst",
        },
        {
          id: "#SK2544",
          name: "Ronald Taylor",
          uname: "rond.track",
          email: "miguel_24@gmail.com",
          join_at: "06-08-2011",
          role: "Manager",
        },
        {
          id: "#SK2545",
          name: "Jacob Hunter",
          uname: "hunt.you010",
          email: "hunt.you010@yahoo.com",
          join_at: "02-12-2006",
          role: "Analyst",
        },
        {
          id: "#SK2544323",
          name: "Mark Anthonio",
          uname: "markant9090",
          email: "mark9090@yahoo.com",
          join_at: "01-10-2006",
          role: "Administrator",
        },
      ],
    };
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="card-title mb-4">
              <div class="d-flex align-items-center justify-content-between">
                <h4>Hash : 8c12962c6072b77f157c5d6459b887</h4>
              </div>
            </div>
            <b-tabs nav-class="nav-tabs-custom" content-class=" text-muted">
              <b-tab active>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-home"></i>
                  </span>
                  <span class="d-none d-sm-inline-block px-5">General</span>
                </template>
                <div class="">
                  <div class="pt-3 pb-2 px-3">
                    <div class="text-muted">
                      <h5>Basic Properties</h5>
                    </div>
                  </div>
                  <div class="card-body border-top">
                    <div class="row mb-2">
                      <div class="col-sm-2">
                        <span class="text-muted mb-2">Threat Name</span>
                      </div>
                      <div class="col-sm-10">
                        <span class="text-muted mb-2"
                          >Trojan:Win32/Decrypter.exe</span
                        >
                      </div>
                    </div>
                    <div class="row mb-2">
                      <div class="col-sm-2">
                        <span class="text-muted mb-2">Filename</span>
                      </div>
                      <div class="col-sm-10">
                        <span class="text-muted mb-2">iDescriptt.exe</span>
                      </div>
                    </div>
                    <div class="row mb-2">
                      <div class="col-sm-2">
                        <span class="text-muted mb-2">Size</span>
                      </div>
                      <div class="col-sm-10">
                        <span class="text-muted mb-2">190.29kb</span>
                      </div>
                    </div>
                    <div class="row mb-2">
                      <div class="col-sm-2">
                        <span class="text-muted mb-2">Uploader</span>
                      </div>
                      <div class="col-sm-10">
                        <span class="text-muted mb-2">Analys 1</span>
                      </div>
                    </div>
                    <div class="row mb-2">
                      <div class="col-sm-2">
                        <span class="text-muted mb-2">MIME TYPE</span>
                      </div>
                      <div class="col-sm-10">
                        <span class="text-muted mb-2">Execute File</span>
                      </div>
                    </div>
                  </div>

                  <div class="">
                    <div class="pt-3 pb-2 px-3">
                      <div class="text-muted">
                        <h5>Hash</h5>
                      </div>
                    </div>
                    <div class="card-body border-top">
                      <div class="row mb-2">
                        <div class="col-sm-2">
                          <span class="text-muted mb-2">MD5</span>
                        </div>
                        <div class="col-sm-10">
                          <span class="text-muted mb-2"
                            >5f358afee76f2a74b1a3443c6012b27b</span
                          >
                        </div>
                      </div>
                      <div class="row mb-2">
                        <div class="col-sm-2">
                          <span class="text-muted mb-2">SHA-1</span>
                        </div>
                        <div class="col-sm-10">
                          <span class="text-muted mb-2"
                            >9sd02962c6072b77f157c5d6459b887ap09dd546a</span
                          >
                        </div>
                      </div>
                      <div class="row mb-2">
                        <div class="col-sm-2">
                          <span class="text-muted mb-2">SHA256</span>
                        </div>
                        <div class="col-sm-10">
                          <span class="text-muted mb-2"
                            >14e966ad882c0aff9d0eb6e221af4946ab315a84d5f6f735cae1b8fe92c07e06</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-user"></i>
                  </span>
                  <span class="d-none d-sm-inline-block px-5">Image (Bin)</span>
                </template>
                --
              </b-tab>
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-envelope"></i>
                  </span>
                  <span class="d-none d-sm-inline-block px-5">Hex</span>
                </template>
                --
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
